import { Nilable } from "@nahuelmorata/ngx-extras";

export interface IDatosEmailGmailLlmDTO {
    id: string;
    remitente: string;
    asunto: string;
    cuerpo: string;
    respuesta: string;
    fecha: string;
}

export class DatosEmailGmailLlmDTO {
    public id = 0;
    public remitente = "";
    public asunto = "";
    public cuerpo = "";
    public respuesta = "";
    public fecha = "";
    public isSelected = false;

    constructor(json: Nilable<Partial<IDatosEmailGmailLlmDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IDatosEmailGmailLlmDTO>) {
        if (json.id != null) {
            // TODO: Cambiar para que del backend venga number
            this.id = Number(json.id);
        }
        if (json.remitente != null) {
            this.remitente = json.remitente;
        }
        if (json.asunto != null) {
            this.asunto = json.asunto;
        }
        if (json.cuerpo != null) {
            this.cuerpo = json.cuerpo;
        }
        if (json.respuesta != null) {
            this.respuesta = json.respuesta;
        }
        if (json.fecha != null) {
            this.fecha = json.fecha;
        }
    }

    public toJSON(): IDatosEmailGmailLlmDTO {
        return {
            id: this.id.toString(),
            remitente: this.remitente,
            asunto: this.asunto,
            cuerpo: this.cuerpo,
            respuesta: this.respuesta,
            fecha: this.fecha
        };
    }
}
